/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://assets.99static.com/start/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1008);


/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

	'use strict';
	
	document.addEventListener('DOMContentLoaded', function () {
	    var categorySelect = document.querySelector('[data-category]');
	    var bundlesField = document.querySelector('[data-bundles]');
	
	    categorySelect.addEventListener('change', function (e) {
	        if (e.target.value === 'logo-design') {
	            bundlesField.style.display = 'block';
	        } else {
	            bundlesField.style.display = 'none';
	        }
	    });
	});

/***/ })

/******/ });


// WEBPACK FOOTER //
// marketing/designConsultation-fd83cfa878b1629319d6.js